<template>
  <div>
    <div class="b-personal-container__btn">
      <div v-if="editFlag">
        <button class="b-global__button" @click="updateInfo">Save Changes</button>
      </div>
      <button @click="checkEditDetails();" class="b-global__button">NEXT</button>
      <div v-if="showModal">
        <Modal @closeModal="showModal= false" @goNext="$emit('goNext') "></Modal>
      </div>
    </div>
    <div class="b-personal-container">
      <div class="b-personal-container-poi-col">
        <div class="b-personal-container__user-details">
          <h3>User details</h3>

          <div>
            <div class="b-personal-container__user-details__data-row">
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Full Name</div>
                <br />
                <div v-if="edit.name">
                  <input
                    type="text"
                    :value="details.name"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'name'})"
                    @blur="edit.name=false"
                  />
                </div>
                <div
                  v-else
                  v-on:dblclick="changeKycDetailHandler('name',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6' ? 'pointer': 'auto'}"
                >{{details.name}}</div>
              </div>
              <div class="b-personal-container__user-details__data" >
                <div class="b-personal-container__user-details__row-heading">PAN Number</div>
                <br />

                <div v-if="edit.PAN_number">
                  <input
                    type="text"
                    :value="details.PAN_number"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'PAN_number'})"
                    @blur="edit.PAN_number=false"
                  />
                </div>
                <div
                  v-else
                  v-on:dblclick="changeKycDetailHandler('PAN_number',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': details.kyc_form_check_status=='2'|| details.kyc_form_check_status=='6' ? 'pointer': 'auto'}"
                >{{details.PAN_number}}</div>
              </div>
            </div>

            <div class="b-personal-container__user-details__data-row" >
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Gender</div>
                <br />

                <div v-if="edit.gender">
                  <select
                    :value="details.gender"
                    @blur="edit.gender=false"
                    @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'gender'})"
                  >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div
                  v-else
                  v-on:dblclick="changeKycDetailHandler('gender',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6' ? 'pointer': 'auto'}"
                >{{details.gender}}</div>
              </div>
              <div class="b-personal-container__user-details__data">
                <div>DOB</div>
                <br />

                <div v-if="edit.date_of_birth">
                  <input
                    type="date"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'date_of_birth'})"
                    @blur="edit.date_of_birth=false"
                    :value="details.date_of_birth"
                  />
                   <!-- <DatePicker
                    format="dd MMM yyyy"
                    input-class="b-personal-container__user-details__data-edit"
                    placeholder="Select DOB"
                    @selected="updateDate"
                    @closed="edit.date_of_birth=false"
                    :value="details.date_of_birth"
                    :clear-button="true"
                    clear-button-icon="fa fa-times-circle"
                    /> -->
                </div>
                <div
                  v-else
                  v-on:dblclick="changeKycDetailHandler('date_of_birth',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6'? 'pointer': 'auto'}"
                >{{details.date_of_birth && customFormatter(details.date_of_birth)}}</div>
              </div>
            </div>

            <div class="b-personal-container__user-details__data-row">
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Father's Name</div>
                <br />

                <div v-if="edit.father_or_spouse">
                  <input
                    type="text"
                    :value="details.father_or_spouse"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'father_or_spouse'})"
                    @blur="edit.father_or_spouse=false"
                  />
                </div>
                <div
                  v-else
                  v-on:dblclick="changeKycDetailHandler('father_or_spouse',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6'? 'pointer': 'auto'}"
                >{{details.father_or_spouse}}</div>
              </div>
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Mother's Name</div>
                <br />

                <div v-if="edit.mother_name">
                  <input
                    type="text"
                    :value="details.mother_name"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'mother_name'})"
                    @blur="edit.mother_name=false"
                  />
                </div>
                <div
                  v-else
                  v-on:dblclick="changeKycDetailHandler('mother_name',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6'? 'pointer': 'auto'}"
                >{{details.mother_name}}</div>
              </div>
            </div>
            <div class="b-personal-container__user-details__data-row">
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Email</div>
                <br />

                <div v-if="edit.email">
                  <input
                    type="text"
                    :value="details.email"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'email'})"
                    @blur="edit.email=false"
                  />
                </div>
                <div
                  v-else
                  v-on:dblclick="changeKycDetailHandler('email',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6'? 'pointer': 'auto'}"
                >{{details.email}}</div>
              </div>
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Mobile Phone</div>
                <br />

                <div v-if="edit.mobile_phone">
                  <input
                    type="text"
                    :value="details.mobile_phone"
                    class="b-personal-container__user-details__data-edit"
                    @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'mobile_phone'})"
                    @blur="edit.mobile_phone=false"
                  />
                </div>
                <div
                  v-else
                  v-on:dblclick="changeKycDetailHandler('mobile_phone',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6'? 'pointer': 'auto'}"
                >{{details.mobile_phone}}</div>
              </div>
            </div>
            <div class="b-personal-container__user-details__data-row" >
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Martial Status</div>
                <br />
                <div v-if="edit.marital_status">
                  <select
                    :value="details.marital_status"
                    @blur="edit.marital_status=false"
                    @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'marital_status'})"
                  >
                    <option value="Married">Married</option>
                    <option value="Unmarried">Unmarried</option>
                  </select>
                </div>
                <div
                  v-else
                  v-on:dblclick="changeKycDetailHandler('marital_status',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6'? 'pointer': 'auto'}"
                >{{details.marital_status}}</div>
              </div>
              <div class="b-personal-container__user-details__data">
                <div class="b-personal-container__user-details__row-heading">Nationality</div>
                <br />
                <div v-if="edit.country_of_nationality">
                  <select
                    :value="details.country_of_nationality"
                    @blur="edit.country_of_nationality=false"
                    @change="$store.commit('updateKycDetail',{value: $event.target.value,key:'country_of_nationality'})"
                  >
                    <option
                      v-for="country in countries"
                      :value="country"
                      :key="country"
                    >{{ country }}</option>
                  </select>
                </div>
                <div
                  v-else
                  v-on:dblclick="changeKycDetailHandler('country_of_nationality',$event)"
                  class="b-personal-container__user-details__text"
                  :style="{'cursor': details.kyc_form_check_status=='2' || details.kyc_form_check_status=='6'? 'pointer': 'auto'}"
                >{{details.country_of_nationality}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="b-personal-container__form" v-if="details.kyc_form_check_status ==='2' || details.kyc_form_check_status=='6'">
          <div class="b-personal-container__form_row" >
            <input
              type="checkbox"
              id="pan"
              value="pan"
              :checked="checkDetails['pan_status']"
              @change="$emit('checkDetail', 'pan_status')"
            />
            <label for="pan">PAN number as per PAN</label>
            <br />
          </div>
          <div class="b-personal-container__form_row">
            <input
              type="checkbox"
              id="name"
              value="name"
              :checked="checkDetails['name']"
              @change="$emit('checkDetail', 'name')"
            />
            <label for="name">Name as per PAN</label>
            <br />
          </div>
          <div class="b-personal-container__form_row" >
            <input
              type="checkbox"
              id="dob"
              value="dob"
              :checked="checkDetails['dob']"
              @change="$emit('checkDetail', 'dob')"
            />
            <label for="dob">DOB as per PAN</label>
            <br />
          </div>

          <div class="b-personal-container__form_row" >
            <input
              type="checkbox"
              id="signature"
              value="signature"
              :checked="checkDetails['signature']"
              @change="$emit('checkDetail', 'signature')"
            />
            <label for="signature">Signature matches as per the PAN</label>
            <br />
          </div>
        </div>
        <!-- <div class="b-personal-container__btn">
          <div v-if="editFlag">
            <button class="b-global__button" @click="updateInfo">Save Changes</button>
          </div>
          <button @click="checkEditDetails();" class="b-global__button">NEXT</button>
          <div v-if="showModal">
            <Modal @closeModal="showModal= false" @goNext="$emit('goNext') "></Modal>
          </div>
        </div> -->
      </div>
      <div class="b-personal-container-poi-col">
        <h3>User Proof</h3>
   
      
        <div class="b-personal-container__img">
          <img v-bind:src="details.url_poi_side1" alt="Proof of address" style="width:100%" />

          <div class="b-personal-container__img-section">
            <p>PAN Image</p>
            <div class="b-personal-container__btn-container" v-if="details.kyc_form_check_status !=='4' && details.kyc_form_check_status !=='5'">
              <div>
                <button
                  @click="rotateImage('url_poi_side1')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('url_poi_side1',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img class="b-personal-container__upload-img" src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>
            </div>
          </div>
        </div>

        <div class="b-personal-container__img">
          <img v-bind:src="details.file_signature" alt="Signature" style="width:100%" />
          <div class="b-personal-container__img-section">
            <p>Signature Image</p>
            <div class="b-personal-container__btn-container" v-if="details.kyc_form_check_status !=='4' && details.kyc_form_check_status !=='5'">
              <div>
                <button
                  @click="rotateImage('file_signature')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('file_signature',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img class="b-personal-container__upload-img" src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>
            </div>
          </div>
        </div>
          <div class="b-personal-container__img">
          <img v-bind:src="details.url_photo" alt="User image" style="width:100%" />
          <div class="b-personal-container__img-section">
            <p>Profile Image</p>
            <div class="b-personal-container__btn-container" v-if="details.kyc_form_check_status !=='4' && details.kyc_form_check_status !=='5'">
              <div>
                <button
                  @click="rotateImage('url_photo')"
                  class="b-global__button b-personal-container__edit-btn"
                >EDIT</button>
              </div>
              <div class="b-personal-container__upload">
                <input
                  type="file"
                  @change="handleUploadFile('url_photo',$event)"
                  accept="image/*"
                  class="b-personal-container__upload-input"
                />
                <img class="b-personal-container__upload-img" src="../../assets/upload.png" />
                <span class="b-perosnal-conatiner__upload-text">Upload</span>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h3>Consent form</h3>

          <!-- SHOW CONSENT FORM -->
          <img
              v-if="details.url_kyc_consent_form"
              :src="details.url_kyc_consent_form"
              style="height: 400px; width: 400px;"
          />
          <div v-else>
            NA
          </div>

          <!-- UPLOAD / REPLACE CONSENT FORM -->
          <label style="height: 50px; width: 200px;">
            <input
                style="height: 50px; width: 200px;"
                type="file"
                @change="handleConsentUpload"
                accept="image/*"
                class="b-personal-container__upload-input"
            />
            <div style="margin-top: 16px; height: 50px; width: 200px; border: 1px solid black;">
              Upload / replace
            </div>
          </label>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

import Modal from "../../commons/modal.vue";
import countries from "../../commons/countries.json";
import moment from "moment";
import axios from "axios";
import Vue from "vue"
import { mapState } from "vuex";

export default {
  components: { Modal },
  data() {
    return {
      edit: {
        name: false,
        father_or_spouse: false,
        mother_name: false,
        PAN_number: false,
        date_of_birth: false,
        residence_status: false,
        gender: false,
        marital_status: false,
        nationality: false,
        email: false,
        mobile_phone: false,
        country_of_nationality: false
      },

      showModal: false,
      countries: countries.countries
    };
  },
  props: {
    checkDetails: {
      type: Object
    },

    details: {
      type: Object,
      required: true
    },
    editFlag: {
      type: Boolean
    }
  },

  computed: {
    ...mapState({
       admin_partner: state => state.kycLogin.admin_partner,
       kyc_verification_type: state => state.kycLogin.kyc_verification_type
    }),    
  },

  methods: {
    async handleConsentUpload (evt) {
      const file = evt.target.files[0]

      const formData = new FormData()
      formData.append("attachment", file)
      formData.append("type", file.type)

      try {
        // UPLOAD FILE
        //const fileUploadResponse = await Vue.kuvera.uploadFile(file, file.type)        
        const fileUploadResponse = await axios.post(`${this.endPoint()}/api/v3/file_upload.json`, formData)
        const fileUrl = fileUploadResponse.data.file_url

        // UPDATE URL TO CVL DATA ON DB
        const kycId = this.$route.params.id
        let cvlData = JSON.parse(JSON.stringify(this.$store.state.kycDetails.copyUserKycData))
        cvlData = {
          ...cvlData,
          cvl_audit: {
            personal: {
              pan_status: "",
              name: ""
            },
            ipv: {
              gender: "",
              video: "",
              url_kyc_consent_form: fileUrl
            },
            address: {
              address_status: ""
            },
            kyc: {}
          }
        }
        cvlData.url_kyc_consent_form = fileUrl
        await axios.put(`${this.endPoint()}/admin/adfes433fkdfggs343434/kyc/${kycId}/cvl_update.json`, { cvl: cvlData })

        // UPDATE DATE ON PAGE
        this.$store.commit('updateKycDetail', { key: 'url_kyc_consent_form', value: fileUrl })

        // SUCCESS MSG
        this.$store.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Success !",
          succesFlag: true
        })
      } catch (e) {
        this.$store.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Failed: " + e.message,
          succesFlag: false
        })
      }
    },

    checkDetail: function(element) {
      let array = ["Personal", element];
      this.$emit("checkDetail", array);
    },
    handleUploadFile: function(key, evt) {
      let files = evt.target.files || evt.dataTransfer.files;
      this.$store.dispatch("uploadFile", {
        file: files[0],
        id: this.$route.params.id,
        key: key
      });
    },
    showEditHandler(value) {
      this.edit[value] = !this.edit[value];
    },
    updateInfo() {
      let obj = {};
      obj.data = this.$store.state.kycDetails.userKycData;
      obj.id = this.$route.params.id;
      if (obj.data.hasOwnProperty("error_message"))
        delete obj.data.error_message;
      this.$store.dispatch("updateKycDetail", obj);
      this.$emit("changeEditFlag", false);
    },
    changeKycDetailHandler(editInfo, event) {
      if ( (!this.details.common_onboarding_digilocker_flow_status || editInfo == 'name') && (this.details.kyc_form_check_status === "2" || this.details.kyc_form_check_status === "6")) {
        this.edit[editInfo] = !this.edit[editInfo];
        this.$emit("changeEditFlag", true);
      } else {
        event.preventDefault();
      }
    },
    checkEditDetails() {
      if (this.editFlag) this.showModal = true;
      else this.$emit("goNext");
    },
    rotateImage(element) {
      
      this.$store.commit("setcroppedImgUrl", this.details[element]);
      this.$router.push({
        name: "kyc-details-edit-img",
        params: {
          id: this.$route.params.id,
          imgname: element,
          partner: this.admin_partner
        }
      });
    },
    updateDate(date){
      this.$store.commit('updateKycDetail',{value: moment(date).format("DD/MM/YYYY"),key:'date_of_birth'});
    },
     customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    endPoint(){
      if (this.admin_partner == "az"){
        return Vue.config.EL_DORADO_API_URL_BIGCO
      }  

      return Vue.config.EL_DORADO_API_URL
    }

  }
};
</script>

<style scoped>
.b-personal-container {
  margin-top: 40px;
  display: flex;

  justify-content: center;
}
.b-personal-container__img {
  width: 358px;
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  border: solid 1px #e0e0e0;
  margin-bottom: 25px;
}
.b-personal-container__form {
  width: 328px;
  border-radius: 8px;
  border: solid 1px #e0e0e0;
  background-color: #ffffff;
  margin: 15px;
}
.b-personal-container__error {
  color: #d8000c;
}
.b-personal-container__form button {
  margin-top: 15px;
}
.b-personal-container__form label {
  margin-left: 10px;
}
.b-personal-container__img-label {
  margin-top: 10px;
  padding-left: 108px;
  font-weight: 600px;
}
.b-personal-container__form_row {
  border-bottom: solid 1px #e0e0e0;
  padding: 10px;
}
.b-personal-container__user-details {
  min-width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.b-personal-container-poi-col {
  display: flex;
  flex-direction: column;

  margin: 30px;
}
.b-personal-container-poi-col h3 {
  text-align: center;
}

.b-personal-container__user-details {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.b-personal-container__user-details__column {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}
.b-personal-container__user-details__row {
  display: flex;
  background: #f4f7f8;
}
.b-personal-container__user-details__row-data {
  max-width: 225px;
  display: flex;
}
.b-personal-container__btn-container {
  display: flex;
  justify-content: space-evenly;
}
.edit,
.save {
  width: 15px;
  height: 16px;
  object-fit: contain;
}
.b-personal-container__user-details__edit {
  display: flex;
}
.b-personal-container__user-details__data {
  padding: 10px;
  width: 328px;
  margin: 10px;
  border-radius: 4px;
  border: solid 1px #e0e0e0;
  background-color: #ffffff;
}

.b-personal-container__user-details__data-edit {
  width: 90%;
  font-size: 16px;
  padding: 4px;
}
.b-personal-container__user-details__row-heading {
  min-width: 265px;
  font-weight: 600;
}

.b-personal-container__user-details__data label {
  margin: 15px;
  padding-top: 10px;
}
/* .b-personal-container__user-details__data input {
  border: none;
  padding: 4px
} */
.b-personal-container__user-details__data select {
  border: none;
  background: none;
  font-size: 16px;

  width: 100%;
}
.b-personal-container__btn {
  display: flex;
  justify-content: center;
}

.b-personal-container__img-section {
  text-align: center;
}
.b-perosnal-conatiner__upload {
  width: 14px;
  height: 14px;
  object-fit: contain;
}
.b-perosnal-conatiner__upload-text {
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  padding-left: 10px;
  letter-spacing: normal;
  text-align: center;
  color: #00bfff;
}
.b-personal-container__user-details__data-row {
  display: flex;
}
.b-personal-container__upload {
  cursor: pointer;
  position: relative;
  margin-top: 13px;
}
.b-personal-container__upload-input {
  -webkit-appearance: none;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.b-personal-container__user-details__text {
  height: 18px;
}
.b-personal-container__edit-btn {
  margin: unset !important;
}
</style>